import { PLACE_TYPE_META, PlaceType } from "~/lib/api";
import { Button } from "~/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { Icon } from "~/components/ui/icons/icon";
import { PlaceTypeIcon } from "~/components/ui/icons/place-type-icons";
import { IconBadge } from "~/components/ui/icon-badge";

interface PlaceTypeMenuProps {
  onSelect: (type: PlaceType) => void;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
}

const PLACE_TYPES = Object.entries(PLACE_TYPE_META) as [PlaceType, { label: string }][];

export default function PlaceTypeMenu({ onSelect, onOpenChange, open }: PlaceTypeMenuProps) {
  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>
        <Button size="fab-lg" title="Add a place">
          <Icon i="add-place" className="size-8" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8} className="max-h-80">
        <DropdownMenuLabel>Select place type</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {PLACE_TYPES.map(([type, { label }]) => (
          <DropdownMenuItem key={type} onClick={() => onSelect(type)} className="gap-3">
            <IconBadge>
              <PlaceTypeIcon type={type} className="size-4" />
            </IconBadge>
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
